import { h, Component } from 'preact';
import StockDetailsPage from '../stock-details-page';
import { FinanceSpinner } from '../glyphs';
import style from './style';
import cx from 'classnames';

import { route } from 'preact-router';
import { stockAPIStreamer } from '@os/cloudquote';
import DynamicStockChart from '../dynamic-stock-chart';
import SymbolDetailTable from '../symbol-detail-table';
import IndexDetailTable from '../index-detail-table';
import { addToRecentlyViewed } from '../stock-recently-viewed';

export default class StockQuotePanel extends Component {
	state = { quote: {} }

	handleSymbolSelect = (sym) => {
		route(`/stockQuote/${sym}`);
	};

	onData = (data) => {
		if (data && data.rows && data.rows.length) {

			let currentSym = this.state.quote.UniqueSymbol;
			let { UniqueSymbol: newSym, SecurityTypeCode: securityType } = data.rows[0];
			// Only attempt to add to recently viewed in local storage if a new security
			if (!currentSym || currentSym !== newSym) addToRecentlyViewed(newSym, securityType);

			this.setState({ quote: data.rows[0] });
		}
	};

	componentWillMount() {
		this.streamer = stockAPIStreamer(this.props.symbol, 'getStockPrice').on('data', this.onData);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.symbol!==this.props.symbol) {
			this.streamer.stream(nextProps.symbol);
		}
	}

	componentWillUnmount() {
		if (this.streamer) this.streamer.end();
	}

	render({ showInWatchlist=true, ...props }, { quote }) {
		if (!quote) return (
			<div class={style['stock-quote-panel']}>
				<FinanceSpinner />
			</div>
		);

		let details = quote.SecurityTypeCode === 'INDEX' ?
			<IndexDetailTable quote={quote} {...props} />
			: <SymbolDetailTable quote={quote} {...props} />;

		return (
			<StockDetailsPage showInWatchlist={showInWatchlist} {...props} class={cx(props.class, style['stock-quote-panel'])}>
				<DynamicStockChart symbol={props.symbol} quote={quote} />
				<div>
					<div class={style['widget-panel']}>
						{ details }
					</div>
				</div>
			</StockDetailsPage>
		);
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-quote-panel/index.js